import React, { useEffect, useState } from 'react';
import { Container, Row, Col }        from 'react-bootstrap';
import { useLocation }                from 'react-router-dom';
import api                            from './AxiosConfig'; 

function Verify() {
  const [message, setMessage] = useState("");
  const [token,   setToken ]  = useState(null);
  const location              = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setToken(queryParams.get('token'));  // Set token when location changes
  }, [location]);  // Only re-run when location changes

  useEffect(() => {
    if (token) {  // Check if token is available before making the API call
      async function verifyToken() {
        console.log("verifyToken called");
        try {
          const response = await api.post('/site/verify', {token: token}, {withCredentials: true });
          setMessage(response.data.message);
        } catch (error) {
          console.log("Error " + error);
          setMessage("A system error occurred. Try again later.");
        }
      }
      verifyToken();
    }
  }, [token]);  // Re-run when token changes

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md="6">
          <h2>Verify Registration</h2>
          <p>token={token}</p>
          <p>{message}</p>
        </Col>
      </Row>
    </Container>
  );
}

export default Verify;
